<template>
    <div class="flex flex-col flex-auto min-w-0 p-6 gap-4">
        <div class="flex-auto p-4 bg-white rounded-lg">
            <div class="pb-0 pt-2">
                <img class="nodoc_image" src="../../../assets/icon/edocument/nodoc.png" alt=""/>
            </div>

            <div class="pt-4 text-12 font-light text-a-gray-afafaf text-center">
                <div class="pt-0 text-21 font-medium">ไม่พบกรมธรรม์อิเล็กทรอนิกส์</div>
                <div class="pt-2 leading-normal">
                    สำหรับ พ.ร.บ. ยังไม่สามารถดาวน์โหลดได้ในขณะนี้
                </div>
            </div>

            <div class="pt-5 pb-32 text-12 font-light text-a-gray-afafaf text-center">
                <div class="leading-normal">
                หากพบปัญหาการใช้งาน<br/>
                ติดต่อศูนย์บริการลูกค้า ธนชาตประกันภัย <br/>
                </div>
                <div class=" text-a-orange-fe5000 underline font-medium">
                    <a class="tel" href="tel:023089222">โทร. 02-308-9222</a>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'EmptyDocument'
}
</script>

<style>

.nodoc_image {
    width: auto;
    height: 279px;
    margin: 0 auto;
    margin-bottom: -65px;
}

</style>
